import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ROUTER_NAVIGATION, RouterNavigationAction} from '@ngrx/router-store';
import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {of} from 'rxjs/';
import {distinctUntilChanged, filter, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {LoadCurrentClientAction} from '../actions/current-client';
import {LoadExternalLinksAction} from '../actions/external-links';
import {ChangeClientAction, userContextActionTypes} from '../actions/user-context';
import {RouterStateUrl} from '../models/router-state-url';

@Injectable()
export class UserContextClientEffect {

  changeClient$ = createEffect(() => { return this.actions$.pipe(ofType(userContextActionTypes.CHANGE_CLIENT),
    debug('Change client action received'),
    switchMap((action: ChangeClientAction) => of<Action>(
      new LoadCurrentClientAction(action.payload.clientId),
      new LoadExternalLinksAction(action.payload.clientId)
      )
    )
  ) });

  changeClientByUrl$ = createEffect(() => { return this.actions$.pipe(
    ofType(ROUTER_NAVIGATION),
    debug('Change client By URL action ROUTER_NAVIGATION received'),
    map((action: RouterNavigationAction<RouterStateUrl>) => _.get(action.payload.routerState.params, 'clientId')),
    filter(clientId => !_.isEmpty(clientId)),
    distinctUntilChanged(),
    map(clientId => new ChangeClientAction({ clientId, redirect: false }))
  ) });

  constructor(private actions$: Actions) {}
}
